import {
  CLEAR_ACCESS_TOKEN,
  SET_ACCESS_TOKEN,
  SET_INITIALIZED,
  SET_ROLES,
  SET_USER,
} from "@/redux/actions/auth-actions";

const initialState = {
  accessToken: null,
  refreshToken: null,
  user: null,
  roles: [],
  isAuthenticated: false,
  isInitialized: false,
};

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACCESS_TOKEN:
      return {
        ...state,
        accessToken: action.payload.token,
        refreshToken: action.payload.refreshToken,
        isAuthenticated: true,
      };
    case SET_USER:
      return { ...state, user: action.payload };
    case SET_ROLES:
      return { ...state, roles: action.payload };
    case SET_INITIALIZED:
      return { ...state, isInitialized: true };
    case CLEAR_ACCESS_TOKEN:
      return {
        ...initialState,
        isInitialized: true,
      };
    default:
      return state;
  }
};

export default AuthReducer;
